import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "about" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "ID Token", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives(_createElementVNode("textarea", {
      style: {"width":"600px","height":"300px"},
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.idToken) = $event))
    }, null, 512), [
      [_vModelText, _ctx.idToken]
    ])
  ]))
}